import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SidebarComponent } from './sidebar.component';
import { NavigationComponent } from './navigation/navigation.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';

@NgModule({
  declarations: [
    SidebarComponent,
    NavigationComponent,
    HeaderComponent,
    FooterComponent
  ],
  imports: [ 
    CommonModule,
    RouterModule
  ],
  providers: [],
  exports: [
    SidebarComponent,
    NavigationComponent,
    HeaderComponent,
    FooterComponent
  ]
})
export class SidebarModule { }
